// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2XS_5","header":"Messages_header__3YjWs"};